/* @flow */

export const DISTANCE_UNIT_KM = 'km';

export const DISTANCE_UNIT_MI = 'mi';

/* Provided by DMS, not used in market-level configurations */
export const DISTANCE_UNIT_M = 'm';

/* Provided by DMS, not used in market-level configurations */
export const DISTANCE_UNIT_YD = 'yd'

/* Market-level configuration units */
const DistanceUnits: Map<string, string> = new Map([
  [ DISTANCE_UNIT_KM, 'Kilometers' ],
  [ DISTANCE_UNIT_MI, 'Miles' ]
]);

export default DistanceUnits;

export const ConvertionDistanceUnits = {
  DISTANCE_UNIT_KM,
  DISTANCE_UNIT_M,
  DISTANCE_UNIT_MI,
  DISTANCE_UNIT_YD
};

export const DefaultDistanceOptions = {
  RADIUS_10: '10',
  RADIUS_25: '25',
  RADIUS_50: '50'
};
